import styles from './VolumeList.module.css'
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import ActiveRecordItem from "../../FormTemplate/ActiveRecordItem/ActiveRecordItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import SelectUnit, {SelectUnitDataInt} from "../../FormTemplate/SelectUnit/SelectUnit";
import TableItem from "../../FormTemplate/TableItem/TableItem";

interface IBanList
{
    ban:string
    [key:string]:any
}
export default function VolumeList()
{
    const banListData =useRef(null)
    const [ldrBanList,rsBanList,exBanList] = useApiQuery("/core/ban/list","get",banListData);

    const volumeListData =useRef<{
        ban:string
    }>(null)
    const [ldrVolumeList,rsVolumeList,exVolumeList] = useApiQuery("/core/volume/list","post",volumeListData);
    const [volumeList, setVolumeList] = useState<any[]>([])




    const [banList, setBanList] = useState<IBanList[]>([])

    const [suBan,setSUBan] = useState<SelectUnitDataInt[]>([])

    const [curBan,setCurBan] = useState<string>("")


    useEffect(()=>{
        loadBanList()
    },[banListData])

    useEffect(()=>{
        const x:SelectUnitDataInt[] =  banList?.map((item)=>{
            return{
                name: `${item?.ban} : ${item?.login}`,
                val: item?.ban
            }
        })
        setSUBan(x)


    },[banList])

    useEffect(()=>{
        if(curBan?.length)        loadVolumeList()

    },[curBan])


    const loadBanList = () =>{
        exBanList().then((e)=>{
            if(e?.success)
            {
                setBanList(e?.payload)

            }
        })
    }

    const loadVolumeList = () =>{

        if(! curBan) return
        volumeListData.current = {
            ban: curBan
        }
        exVolumeList().then((e)=>{
            if(e?.success)
            {
                setVolumeList(e?.payload)
            }
        })
    }


    const handleSelectBan = (data: any) =>{
        console.log("data",data)
        if(!Array.isArray(data) || !data[0]) return
        setCurBan(data[0])

    }



    return(
        <div className={styles.mainCont}>
            <MainFormTemplate title={`Трафик по бану [${curBan}]`} maxWidth={"800px"} >
                <div className={"row w-100"}>
                    <div className={"col-sm-12"}>
                        <SelectUnit
                        capt={"выберите бан"}
                        inData={suBan}
                        getVal={handleSelectBan}
                            />
                    </div>
                </div>

            </MainFormTemplate>
            <WaitLoader loading={ldrBanList} api={rsBanList} onlyLoading={true}>
                <TableItem
                    data={volumeList}
                    column={[
                        {
                            type: 0,
                            maxLen: 11,
                            fieldId:"ban",
                            title: "ban",
                            mode: "f",
                        },
                        {
                            type: 2,
                            maxLen: 11,
                            fieldId:"date",
                            title: "Дата",
                            mode: "sf",
                        },
                        {
                            type: 1,
                            maxLen: 20,
                            fieldId:"volumeGb",
                            title: "Трафик (Гб.)",
                            mode: "sf",
                        },
                        {
                            type: 1,
                            maxLen: 20,
                            fieldId:"volume",
                            title: "Трафик (Мб.)",
                            mode: "sf",
                        },

                    ]}
                    onPageCount={50}
                    onReload={loadVolumeList}
                    exportExcel={true}
                    saveState={false}




                ></TableItem>
            </WaitLoader>



        </div>
    )
}